import React from "react";
import { useTranslation } from "react-i18next";
import { DirectionLabel, SortOption } from "./SortSelect";

export type DateAmountSortField = "valueDate" | "amount";

export const useDateAmountSortOptions =
  (): SortOption<DateAmountSortField>[] => {
    const { t } = useTranslation();

    const option = (
      field: DateAmountSortField,
      direction: TableSortDirection
    ): SortOption<DateAmountSortField> => {
      const fieldLabel = t(
        `components.depotsStatistic.bookingsTable.mobile.sort.${field}`
      );
      return {
        field,
        direction,
        label:
          field === "valueDate" ? (
            t("domains.investments.investmentTable.mobile.sortOption", {
              field: fieldLabel,
              direction: t(
                `components.depotsStatistic.bookingsTable.mobile.sort.${direction === "DESC" ? "newest" : "oldest"}`
              ),
            })
          ) : (
            <DirectionLabel
              field={fieldLabel}
              direction={direction}
              directionText={t(
                `domains.investments.investmentTable.mobile.${direction === "DESC" ? "descendingNumber" : "ascendingNumber"}`
              )}
            />
          ),
      };
    };

    return [
      option("valueDate", "DESC"),
      option("valueDate", "ASC"),
      option("amount", "DESC"),
      option("amount", "ASC"),
    ];
  };
